<template>
  <v-btn
    v-bind="{...button}"
    :style="customStyle"
    :disabled="buttonDisabled"
    :loading="loading"
    class="generic-button"
    @click="runAction"
  >
    {{ text }}
  </v-btn>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    formInvalid: {
      type: Boolean,
      default: false
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    text() {
      return _.get(this.component, 'text', '')
    },
    action() {
      return _.get(this.component, 'action', '')
    },
    // https://vuetifyjs.com/en/api/v-btn/
    button() {
      return _.get(this.component, 'props.button', {})
    },
    customStyle() {
      return _.get(this.component, 'props.style', {})
    },
  },
  created() {
    this.$emit('button-registered', this.action)
  },
  methods: {
    runAction() {
      if (this.action) {
        this.$emit('action-triggered', this.action)
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
